import React from 'react'
import { Route, NavLink } from 'react-router-dom'

const StatefulNavLink = ({
  to,
  exact = false,
  children,
  ...rest
}) => (
  <Route path={to} exact={exact}>
    {({ match }) => (
      <NavLink to={to} {...rest}>
        {children(match)}
      </NavLink>
    )}
    </Route>
)

export default StatefulNavLink
